import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { TamanhosPecasViewModel } from 'models/confeccoes/TamanhosPecasViewModel';

@Injectable()
export class TamanhosPecasServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('TamanhoPecas', http);
  }

  buscarPorGradeTamanho(idGradeTamanho: number) {
    return this.getAsPromise<TamanhosPecasViewModel[]>(`getByGradeId/${idGradeTamanho}`);
  }

}